import { render, staticRenderFns } from "./ConvoAttributes.vue?vue&type=template&id=21591614&scoped=true&"
import script from "./ConvoAttributes.vue?vue&type=script&lang=js&"
export * from "./ConvoAttributes.vue?vue&type=script&lang=js&"
import style0 from "./ConvoAttributes.vue?vue&type=style&index=0&id=21591614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21591614",
  null
  
)

export default component.exports